import React, { useState } from "react";
import { Button, Input, Select } from "antd";
import { getDataWithEndpoint, request } from "../../../functions/request";
import {
  formatDateHourToBR,
  updateData,
} from "../../../functions/functionsUtility";
import { DescriptionsLayout } from "../../../layout";
import { FaSave } from "react-icons/fa";

const estados = [{ value: "SP", label: "São Paulo" }];

const cotacoesLabel = [
  { value: "tras_boi", label: "Traseiro Boi" },
  { value: "diant_boi", label: "Dianteiro Boi" },
  { value: "tras_vaca", label: "Traseiro Vaca" },
  { value: "diant_vaca", label: "Dianteiro Vaca" },
  { value: "tras_boi_av", label: "Tras. Boi Avulso" },
  { value: "tras_vaca_av", label: "Tras. Vaca Avulso" },
  { value: "boi_casado", label: "Boi Casado" },
  { value: "vaca_casado", label: "Vaca Casado" },
  { value: "pt_agu_boi", label: "PA Boi" },
  { value: "pt_agu_vaca", label: "PA Vaca" },
  { value: "pt_agu_boi_esp", label: "PA Boi Especial" },
];

export default function InterboisCarneInNatura() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const aux = Object.entries(cotacoesData).map(([key, value], index) => {
    if (key !== "boi_data" && key !== "boi_uf") {
      const cotLabel = cotacoesLabel.find((label) => label.value === key);
      return {
        label: cotLabel ? cotLabel.label : key,
        children: (
          <Input
            className="input-number"
            value={value}
            disabled={isLoading}
            onChange={(event) => {
              const inputValue = event.target.value;
              const formattedValue = inputValue;
              const newData = {
                ...cotacoesData,
                [key]: formattedValue,
              };
              setCotacoesData(newData);
            }}
          />
        ),
        span: 2,
      };
    }
  });

  const items = [
    {
      label: "Estado",
      children: (
        <Select
          showSearch
          style={{ width: "100%" }}
          optionFilterProp="children"
          placeholder="Selecione um estado"
          filterOption={(input, option) =>
            (option?.label ?? "").includes(input)
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={estados}
          loading={isLoading}
          onChange={(value) => {
            setIsLoading(true);
            setCotacoesData([]);
            getDataWithEndpoint(
              "boi_carne_natura",
              `getBoiCarneNaturabyuf?uf=${encodeURIComponent(value)}`,
              "updateBoiCarneNatura"
            )
              .then((res) => {
                setCotacoesData(res);
              })
              .finally(() => {
                setIsLoading(false);
              });
          }}
          allowClear={true}
        />
      ),
      span: 3,
    },
    {
      label: "Última Alteração",
      children: formatDateHourToBR(cotacoesData.boi_data),
      span: 3,
    },
  ];

  return (
    <>
      <DescriptionsLayout
        title={"Interbois - Carne In Natura"}
        items={[...items, ...aux.filter(Boolean)]}
        extra={
          <div style={{ padding: 10, display: "flex", gap: 10 }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              icon={<FaSave />}
              disabled={isLoading}
              onClick={async () => {
                updateData({
                  ...cotacoesData,
                  endpoint: "updateBoiCarneNatura",
                  path: "boi_carne_natura",
                });
              }}
            >
              Atualizar
            </Button>
          </div>
        }
        isLoading={isLoading}
      />
    </>
  );
}
